var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "bg-primary-25 flex flex-col text-left justify-center px-4 text-gray-900 text-base font-medium",
    style: { "height": "52px" }
};
const _hoisted_2 = {
    key: 0,
    style: { "height": "498px" },
    class: "overflow-y-scroll px-3 flex flex-col space-y-3 py-3"
};
import UICollapse from '@/components/common/UICollapse.vue';
import { getFilter } from '@/compositions/useCreateFilterObject';
import { filters } from '@/compositions/useFilterOptions';
import { computed, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FiltersTool',
    props: {
        canvasCtx: {
            type: Object,
            require: true,
        },
        loaded: {
            type: Boolean,
            require: true,
        },
        reset: {
            type: Boolean,
        },
    },
    emits: ['fabricChange', 'framesCreated'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const filterImageData = ref({});
        const setPreview = ref(false);
        const selectedFilter = ref('');
        const defaultPreviewImage = ref('');
        const loadedCropper = computed(() => props.loaded);
        const isReset = computed(() => props.reset);
        watch(loadedCropper, () => __awaiter(this, void 0, void 0, function* () {
            try {
                if (loadedCropper.value && !setPreview.value) {
                    emits('framesCreated');
                }
            }
            catch (error) {
                // Error for filter image
            }
        }));
        watch(isReset, () => {
            if (!isReset.value)
                return;
            selectedFilter.value = '';
        });
        function setFilter(filterOption, stopChangeEvent) {
            return __awaiter(this, void 0, void 0, function* () {
                if (filterOption.filters.length) {
                    selectedFilter.value = filterOption.value;
                    const filters = [];
                    for (const filter of filterOption.filters) {
                        filters.push(yield getFilter(filter.name, filter.value));
                    }
                    applyFilter(filters, stopChangeEvent);
                }
            });
        }
        function applyFilter(filters, stopChangeEvent) {
            const obj = props.canvasCtx.item(0);
            obj.filters = [];
            for (const filter of filters) {
                obj.filters[filter.index] = filter.filter;
            }
            obj.applyFilters();
            props.canvasCtx.renderAll();
            if (!stopChangeEvent)
                emits('fabricChange');
        }
        function clearFilter() {
            const obj = props.canvasCtx.item(0);
            obj.filters = [];
            obj.applyFilters();
            props.canvasCtx.renderAll();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('filters.title')), 1),
                (__props.canvasCtx)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filters), (filter) => {
                            return (_openBlock(), _createBlock(UICollapse, {
                                key: filter.title,
                                options: filter.options,
                                title: filter.title,
                                "canvas-ctx": __props.canvasCtx,
                                url: filter.url,
                                "filter-image": filterImageData.value,
                                "selected-option": selectedFilter.value,
                                defaultPreviewImage: defaultPreviewImage.value,
                                onSetFilters: setFilter
                            }, null, 8, ["options", "title", "canvas-ctx", "url", "filter-image", "selected-option", "defaultPreviewImage"]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
